/**
 * Created by ori on 25/07/16.
 */
 import React from 'react';
 import {Router, Route, IndexRoute} from 'react-router';
 import IndexLink from 'react-router';

 import Main from './pages/Main';
 import Home from './pages/Home';
 import Build from './pages/Build';

 import Login from './pages/Login';
 import VerifyEmail from './pages/VerifyEmail';
 import Signup from './pages/Signup';
 import ContactUs from './pages/ContactUs';
 import NoMatch from './pages/NoMatch';

 export default [

	     <Route path="/" component={Main} >
	         <IndexRoute component={Home}/>
	         <Route path="home" component={Home}/>
	         <Route path="newbuild" component={Build}/>
	         <Route path="login" component={Login}/>
	         <Route path="signup" component={Signup}/>
	         <Route path="contact_us" component={ContactUs}/>
	         <Route path="verify/:random" component={VerifyEmail}/>
	         <Route path="*" component={Home}/>
	     </Route>
 ];


// WEBPACK FOOTER //
// ./src/js/routes.js